import { useState } from "react"
import Modal from "./Modal"
import { getApiErrorMessage } from "../../utils/errorMessage"

const inputClass =
  "w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-100"

// Creates a billing category under a company (e.g. "Water", "Potatoes"). Bill
// accounts are then grouped under a category.
function AddCategoryModal({ providerId, providerName, onClose, onCreate }) {
  const [form, setForm] = useState({ name: "", kind: "generic", description: "" })
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState("")

  const submit = async (event) => {
    event.preventDefault()
    if (submitting) return
    setSubmitting(true)
    setError("")
    try {
      await onCreate(providerId, form)
      onClose()
    } catch (err) {
      setError(getApiErrorMessage(err, "Failed to create category."))
      setSubmitting(false)
    }
  }

  return (
    <Modal
      title="New category"
      subtitle={providerName ? `Under ${providerName}` : "Group the bills you issue"}
      icon="tags"
      onClose={onClose}
      footer={
        <button
          type="submit"
          form="ut-create-category-form"
          disabled={submitting}
          className="w-full rounded-xl bg-teal-600 py-2.5 text-sm font-bold text-white transition-colors hover:bg-teal-700 disabled:opacity-60"
        >
          {submitting ? "Creating…" : "Create category"}
        </button>
      }
    >
      <form id="ut-create-category-form" onSubmit={submit} className="space-y-3">
        {error && (
          <p className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs font-medium text-red-700">{error}</p>
        )}
        <div>
          <label className="mb-1 block text-xs font-semibold text-slate-600">Category name</label>
          <input
            value={form.name}
            onChange={(event) => setForm({ ...form, name: event.target.value })}
            className={inputClass}
            placeholder="e.g. Water"
            required
            autoFocus
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-semibold text-slate-600">Type</label>
          <select
            value={form.kind === "trash" ? "generic" : form.kind}
            onChange={(event) => setForm({ ...form, kind: event.target.value })}
            className={inputClass}
          >
            <option value="generic">Other</option>
            <option value="water">Water</option>
          </select>
          <p className="mt-1 text-[11px] text-slate-400">Only Water is metered; everything else (trash, service fees…) is a flat "Other" charge. Name it whatever you like above.</p>
        </div>
        <div>
          <label className="mb-1 block text-xs font-semibold text-slate-600">Description</label>
          <input
            value={form.description}
            onChange={(event) => setForm({ ...form, description: event.target.value })}
            className={inputClass}
            placeholder="Optional"
          />
        </div>
      </form>
    </Modal>
  )
}

export default AddCategoryModal
